import Cookies from "universal-cookie";

/**
 * Gets the current user's role from cookies
 * @returns {string|undefined} The user's role (e.g., 'admin', 'user') or undefined if not set
 */
export const getUserRole = () => {
  const cookies = new Cookies();
  return cookies.get("role");
};

/**
 * Checks if the current user is an admin
 * @returns {boolean} True if the user is an admin, false otherwise
 */
export const isAdmin = () => {
  const role = getUserRole();
  return role === "admin";
};

/**
 * Checks if the user has a specific role
 * @param {string} roleToCheck - The role to check against
 * @returns {boolean} True if the user has the specified role, false otherwise
 */
export const hasRole = (roleToCheck) => {
  const role = getUserRole();
  return role === roleToCheck;
};
